module.exports = __webpack_public_path__ + "static/media/android_large_banner.f8f8cbb4.jpg";